<template>
    <div class="storyOfChina">
      <div class="page_top">
        <a href="http://storyofchina.cn/" target="_blank"><img src="../img/storyofchina/enter.png" alt="" class="enter"></a>
      </div>

      <carousel-3d ref="carousel" v-if="videoList.length>0" :perspective="0" :controlsWidth="45" :controlsHeight="65" display="1" @after-slide-change="slideChange()" space="200" inverseScaling="0" :width="width" :height="height" class="carousel-container">
          <slide v-for="(slide, i) in videoList" :index="i" :key="i">
              
              <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }" >
                  <div class="playCon" @click="goDetail(slide)">
                    <span class="emptySpan" v-if="!slide.vid"><img src="../img/storyofchina/emptyspan.png" alt="" ></span>
                    <img v-if="slide.vid" src="../img/storyofchina/play_1.png" alt="" class="play haveVideoPlay">
                    <img v-if="!slide.vid" src="../img/storyofchina/play.png" alt="" class="play" >
                  </div>
                  <div class="text_bj" :class="{'finish': slide.vid}" @click="goDetail(slide)">
                      <div class="text" @click="goDetail(slide)">
                          <h5 class="cn">{{slide.title}}</h5>
                      </div>
                  </div>
                  <img v-if="slide.image_url" class="bg" :data-index="index" @click="goDetail(slide)" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="slide.image_url">
                  <div v-if="!slide.image_url" class="empty"></div>
              </template>
          </slide>
      </carousel-3d>
      <div class="storyFooter">
        版权所有 © 中文联盟 
      </div>
      <!-- <swiper
        ref="mySwiper" :options="swiperOptions" class="carousel-container"
      >
        <swiper-slide  v-for="(slide, i) in videoList" :index="i" :key="i" >
          <div class="playCon">
            <span class="emptySpan" v-if="!slide.vid"><img src="../img/storyofchina/emptyspan.png" alt="" ></span>
            <img v-if="slide.vid" src="../img/storyofchina/play_1.png" alt="" class="play haveVideoPlay">
            <img v-if="!slide.vid" src="../img/storyofchina/play.png" alt="" class="play" >
          </div>
          <div class="text_bj">
              <div class="text" @click="goDetail(slide)">
                  <h5 class="cn">{{slide.title}}</h5>
              </div>
          </div>
          <img v-if="slide.image_url" class="bg" @click="goDetail(slide)" :src="slide.image_url">
          <div v-if="!slide.image_url" class="empty"></div>
        </swiper-slide>
      </swiper> -->

      <!-- 视频播放弹框 -->
    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay">
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <!-- <ali-player
          v-if="isPlay"
          :useFlashPrism="false"
          :useH5Prism='true'
          :autoplay="true"
          :isLive="false"
          :rePlay="false"
          :showBuffer="true"
          showBarTime="5000"
          width="80%" 
          height="700px" 
          controlBarVisibility="always"
          :encryptType="1"
          :vid="vid"
          :playauth="auth.PlayAuth"></ali-player> -->
					<TCPlayer :options="options" style="width: 80%; height: 700px"></TCPlayer>
        </div>
      </div>
    </transition>
    </div>
</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';
import aliPlayer from './aliplayer'
import TCPlayer from './common/TCPlayer'
export default {
    name: 'storyofchina',
    components: {
    Carousel3d,
    Slide,
    aliPlayer,
		TCPlayer
  },
    data: function () {
        return {
					options:{
						fileID: "",
						appID: "1500035244",
						autoplay: true,
						psign:"",
					},
          swiperOptions: {
            loop: true,
            // autoplay: true,
            spaceBetween: 0,
            speed: 500,
            effect : 'coverflow',
            loopedSlides: 3,
            slidesPerView: 'auto',
            centeredSlides: true,
            coverflowEffect: {
              rotate: 0,
              stretch: 200,
              depth: 300,
              modifier: .8,
              slideShadows: false
            },
            pagination: {
              el: '.swiper-pagination'
            },
            // Some Swiper option/callback...
          },
          isPlay: false,
          width: 800,
          height: 4.9,
          videoList: [
            {
              vid: '1397757899900028045',
              title: '第三届“用英语讲中国故事”活动启动仪式',
              image_url: require('../img/storyofchina/storyofchina.jpg')
            },
            // {
            //   vid: '',
            //   title: '嘉宾致辞',
            //   image_url: ''
            // },
            // {
            //   vid: '',
            //   title: '启动仪式',
            //   image_url: ''
            // },
            // {
            //   vid: '',
            //   title: '圆桌论坛',
            //   image_url: ''
            // }
          ],
          currentVideo: '',
          auth: '',
          vid: ''
        }
    },
    mounted() {
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
      this.width = htmlWidth/19.2 * 8
      this.height = htmlWidth/19.2 * 4.9
    },
    methods: {
      slideChange(r) {
        console.log(this.$refs.carousel)
      },
      async goDetail(detail) {
        if(!detail.vid) {
          this.$message({
            message: "敬请期待!",
            type: "warning",
          })
          return
        }
        let res = await this.$utils.get('/subject/lesson/getvideoauth', { vid: detail.vid})
				if (res.data.success) {
					console.log(res.data)
					this.options.fileID = detail.vid;
					this.options.psign = res.data.data;
					this.isPlay = true
				}
      },
      closeVideo() {
        // var myvideo = document.getElementById("liveVideo")
        // if (!myvideo.paused) {
        //     myvideo.pause()
        // }
        this.isPlay = false
      },
    }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.storyOfChina {
    position: fixed;
    width: 100%;
    height: 100%;
    // min-height: 100vh;
    background-image: url(../img/storyofchina/bg.png);
    background-size: cover;
    min-width: 12rem;
    // min-height: 1200px;
    overflow-y: auto;
    font-family: 'Microsoft YaHei';
    .page_top {
      width: 100%;
      height: 338px;
      position: relative;
      .enter {
        // position: absolute;
        // top: 27%;
        left: 0;
        right: 0;
        margin: auto;
        width: 1.87rem;
        margin-top: 27vh;
        margin-left: calc(50% - .935rem);
      }
    }
    .carousel-container {
      // position: absolute;
      width: 12rem;
      height: 5.4rem;
      // top: 40%;
      left: 0;
      right: 0;
      margin: auto;
      margin-top: 4vh;
      // padding-bottom: 1rem;

      .bg{
        width: 8rem;
        height: 100%;
        box-sizing: border-box;
        cursor: pointer;
        background-color: #53514e;
        box-shadow: 1px 2px 15px 0px 
          rgba(109, 0, 0, 0.74);
        border-style: solid;
        border-width: 6px;
        border-image-source: linear-gradient(0deg, 
          #fdd189 0%, 
          #fab966 25%, 
          #f6a142 50%, 
          #fdd18f 100%);
        border-image-slice: 1;
      }
      
      .playCon {
        text-align: center;
        width: 3.5rem;
        position: absolute;
        top: 1.53rem;
        left: 0;
        right: 0;
        margin: auto;
        display: inline-block;
        cursor: pointer;
        .emptySpan {
          img {
            width: 2.8rem;
	          height: 0.8rem;
          }
        }
        .play {
          display: block;
          width: 0.72rem;
	        height: 0.72rem;
          border: none;
          margin: 0.15rem auto;
        }
        .haveVideoPlay {
          margin-top: 0.85rem;
        }
        
      }
      .empty {
        background-color:rgba(0,0,0,0);
        width: 8rem;
        height: 100%;
        box-sizing: border-box;
        cursor: pointer;
        background-color: #53514e;
        box-shadow: 1px 2px 15px 0px 
          rgba(109, 0, 0, 0.74);
        border-style: solid;
        border-width: 6px;
        border-image-source: linear-gradient(0deg, 
          #fdd189 0%, 
          #fab966 25%, 
          #f6a142 50%, 
          #fdd18f 100%);
        border-image-slice: 1;
      }
      .text_bj{
            // display: none;
            width: 6.43rem;
            height: 0.6rem;
            // background-color: rgba(#fab55e, 0.5);
            background: url('../img/storyofchina/text-bg.png') no-repeat center;
            background-size: 100%;
            position: absolute;
            bottom: 0;
            z-index: 1;
            left: 0;
            margin: auto;
            cursor: pointer;
            img {
              width: 0.55rem;
              vertical-align: text-top;
              margin-top: 0.18rem;
              margin-left: 0.1rem;
            }
            .text{
                width: calc(100% - 1rem);
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 0.6rem;
                letter-spacing: 0px;
                color: #863c2b;
                margin-left: 16px;
                h5{
                    color:#863c2b;
                    // font-size: .18rem;
                }
                h5.en{
                    font-size: .14rem;
                    margin-top: .1rem;
                }
            }
      }
      .finish {
        background: url('../img/storyofchina/text-bg-finish.png') no-repeat center;
        .text {
          color: #a80000;
          font-weight: bold;
        }
      }
    .play-btn {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 1rem;
      height: 1rem;
      .btn {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        width: 0.2rem;
      }
      .message {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        width: 1rem;
        height: 1rem;
        animation:rot 15s linear infinite;
      }
    }
  }
    }
#videoPlayWrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  .videoContent {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .closeVideo {
      position: absolute;
      right: 20px;
      top: 10px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
    }
    .videoContainer {
      text-align: center;
      width: 100%;
      video {
        width: 62%;
        max-height: 100vh;
      }
    }
  }
}
.storyFooter {
  width: 100%;
  // position: fixed;
  bottom: 0.32rem;
  margin-top: .5rem;
  text-align: center;
  font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 1px;
	color: #f9958f;
}
</style>
<style lang="scss">
.storyOfChina .carousel-container {
  .carousel-3d-controls {
    // z-index: 2;
    // bottom: -0.4rem;
    // top: initial;
    // text-align: center;
    
  }
}

.prev {
    background:url('../img/storyofchina/arrow.png') no-repeat center center;
    background-size: cover;
    width: .8rem;
    height: 1rem;
}
.next {
    background:url('../img/storyofchina/arrow.png') no-repeat center center;
    background-size: cover;
    transform: rotate(180deg);
    width: .4rem;
    height: .7rem;
}
.prev span, .next span{
    display: none;
}
</style>
